var map = {
	"./AIRobot.js": "J89x",
	"./appointment.js": "YyxU",
	"./claim.js": "gUku",
	"./client/client.js": "zRZh",
	"./client/index.js": "dPG8",
	"./cockpit.js": "bSOg",
	"./dataManage/bi.js": "Cf39",
	"./dataManage/dataManage.js": "ePCC",
	"./dataManage/index.js": "mMip",
	"./feiche/batch.js": "G9i0",
	"./feiche/index.js": "2tTJ",
	"./feiche/insurance.js": "h0Jx",
	"./feiche/order.js": "v0dB",
	"./feiche/policy.js": "Xfja",
	"./feiche/program.js": "xeUv",
	"./feiche/setting.js": "6PHh",
	"./feiche/statistics.js": "wmNF",
	"./feiche/tuan.js": "95pp",
	"./finance/finance.js": "ccX1",
	"./finance/index.js": "L1Xq",
	"./home.js": "roEk",
	"./human/index.js": "2yzh",
	"./human/organization.js": "pfCd",
	"./human/people.js": "flvh",
	"./human/personnel.js": "RWhq",
	"./human/role.js": "SeMm",
	"./human/salary.js": "F+7C",
	"./human/train.js": "71fK",
	"./instantAssistance.js": "J6Ho",
	"./insurance.js": "Ks20",
	"./issuecontrol.js": "3Qb5",
	"./jobnum.js": "DIwZ",
	"./marketing.js": "/r2I",
	"./myhome/index.js": "inSj",
	"./myhome/myhome.js": "Fbdr",
	"./organization.js": "iPao",
	"./policy.js": "ygVm",
	"./product/index.js": "ULgm",
	"./product/product.js": "RkF3",
	"./product/protocol.js": "og/B",
	"./quote.js": "cOCY",
	"./report.js": "QJlH",
	"./role.js": "THZS",
	"./scheme.js": "37WQ",
	"./servicePackage.js": "fQwv",
	"./setting/announcement.js": "DztV",
	"./setting/backups.js": "mHzq",
	"./setting/document.js": "09Ai",
	"./setting/index.js": "7mXR",
	"./setting/log.js": "1btv",
	"./setting/security.js": "7IiX",
	"./setting/workProgressManage.js": "xuxa",
	"./train/index.js": "erYn",
	"./ultimate/analysis.js": "gSk2",
	"./ultimate/embranchment.js": "/2i0",
	"./ultimate/finance.js": "VlA7",
	"./ultimate/index.js": "KLMi",
	"./ultimate/insurance.js": "6k0T",
	"./ultimate/report.js": "Udpc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wKid";


//////////////////
// WEBPACK FOOTER
// ./src/router ^(?!\.\/index).*\.js$
// module id = wKid
// module chunks = 226